import { BasketballEventStatusId } from '@collector/sportsapi-client-legacy'

import {
  GetEventClockSeconds,
  GetEventClockTime,
  GetEventStatusPeriodLengthMinutes,
  IsValidEventClockTime,
  SECONDS_IN_MINUTE,
} from '../../configuration'

const eventStatusIdsQuarter: BasketballEventStatusId[] = [
  BasketballEventStatusId.FirstQuarter,
  BasketballEventStatusId.SecondQuarter,
  BasketballEventStatusId.ThirdQuarter,
  BasketballEventStatusId.FourthQuarter,
  BasketballEventStatusId.FirstHalf,
  BasketballEventStatusId.SecondHalf,
]

const eventStatusIdsOvertime: BasketballEventStatusId[] = [
  BasketballEventStatusId.FirstOvertime,
  BasketballEventStatusId.SecondOvertime,
  BasketballEventStatusId.ThirdOvertime,
  BasketballEventStatusId.FourthOvertime,
  BasketballEventStatusId.FifthOvertime,
]

export const getEventStatusPeriodLengthMinutes: GetEventStatusPeriodLengthMinutes =
  (eventStatusId, periodLength, extraPeriodLength) => {
    if (
      eventStatusIdsQuarter.includes(eventStatusId as BasketballEventStatusId)
    ) {
      return periodLength
    }

    if (
      eventStatusIdsOvertime.includes(eventStatusId as BasketballEventStatusId)
    ) {
      return extraPeriodLength
    }

    return 0
  }

export const getEventClockSeconds: GetEventClockSeconds = (
  clockTime,
  periodLengthMinutes,
  _,
  __,
  isTimerDirectionDown,
) => {
  if (isTimerDirectionDown) {
    return periodLengthMinutes! * SECONDS_IN_MINUTE - clockTime
  }

  return clockTime
}

export const isValidEventClockTime: IsValidEventClockTime = ({
  minute,
  second,
  periodLengthMinutes,
}) => {
  if (second === 0) {
    return minute <= periodLengthMinutes!
  }

  return minute < periodLengthMinutes!
}

export const getEventClockTime: GetEventClockTime = (
  minute,
  second,
  periodLengthMinutes,
  isTimerDirectionDown,
) => {
  const seconds = minute * SECONDS_IN_MINUTE + second

  if (isTimerDirectionDown) {
    return periodLengthMinutes! * SECONDS_IN_MINUTE - seconds
  }

  return seconds
}
